module.exports = __webpack_public_path__ + "img/朱双.8512d3fb.jpg";